import styled from 'styled-components';

export const LeftBloackMainWrap = styled.div(
  props => `
        width: 27%;
        display: flex;
        padding-right: ${props.theme.spacing.large.l40};
        @media (max-width: 768px){
            width:100%;
            padding-right: 0;
            max-width:90%;
            margin:0 auto;
        }
    `,
);

export const LeftInnerBlock = styled.div(
  props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.white.base};
        border-radius: 1rem;
        box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
        flex-direction: column;
        padding: ${props.theme.spacing.large.l20};
        align-self: flex-start;
    `,
);

export const LogoWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 14px;
    `,
);

export const LogoImgSizeText = styled.p(
  props => `
        text-align: center;
        color: #4a4a4a;
    `,
);

export const LogoImgWrap = styled.div(
  props => `
        width:16rem;
        height: 16rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.8rem;
        background-image: linear-gradient(45deg, #ace143, #219393);
        position: relative;
        margin-bottom: ${props.theme.spacing.large.l16};
        background-size: contain;
        background-repeat: no-repeat;
        
        .profileImage {
            width: 100%;
            height: 100%;
            background-color: white;
        }
    `,
);

export const UserLogo = styled.img(
  props => `
        width:16rem;
        height:16rem;
        border-radius: 0.8rem;
    `,
);

export const AddLogoTag = styled.div(
  props => `
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.base};
        border-radius: 2rem;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
        cursor: pointer;
        align-self: center;
        position: absolute;
        bottom: -1.6rem;
        input {
          display: none;
        }
    `,
);

export const TagText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.medium};
    `,
);

export const NameWrap = styled.div(
  props => `
        display: flex;
        padding: ${props.theme.spacing.large.l20} 0;
        align-items: center;
        justify-content: center;
    `,
);

export const NameText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font20};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-align: center;
    `,
);

export const MenuListWrap = styled.ul(
  props => `
        display: flex;
        width:100%;
        list-style: none;
        flex-direction: column;

        li{
            width:100%;
            display: flex;
            padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l25};
            cursor: pointer;
            align-items: center;
            font-size: ${props.theme.font.large.font14};
            color: ${props.theme.colors.grey.base};
            font-weight: ${props.theme.font.fontWeight.medium};
            border-radius: ${props.theme.misc.borderRadius.base};
            &.active{
                background-color: ${props.theme.colors.blue.light01};
                color: ${props.theme.colors.blue.base};
            }
            &.hover{
                background-color: ${props.theme.colors.blue.light01};
                color: ${props.theme.colors.blue.base};
            }
        }

        @media(max-width:768px){
            display: none;
        }
    `,
);
